import dynamic from 'next/dynamic'
import { useEffect, useMemo, useRef } from 'react'
import { useGridBlock, usePage } from '../../contexts'
import { colors, postHeight } from '../../styles/GlobalVariables'
import { IPost, isHomepage, LayoutMobile } from '../../types'
import Credits from '../DateAndWriter/Credits'
import { Image } from '../Image/Image'
import Link from '../Link/Link'
import { utils } from '../Player/Helpers'
import { Shave } from '../Shave/Shave'
import {
  Container,
  PromoStrip,
  SecondaryTitle,
  TextContainer,
  Thumbnail,
  ThumbnailContainer,
  Title,
} from './Post.styles'
// import { PlayButton } from '../../icons'
import PlayButton from '/public/assets/images/svg/play-button.svg'
import { shouldHideDate } from './helpers'

type Props = {
  post: IPost
  layoutMobile: LayoutMobile
  hideSecondaryTitle?: boolean
  height?: string
  className?: string
  leftPadded?: boolean
  maxLines?: number
}

export const Post = ({
  post,
  layoutMobile,
  hideSecondaryTitle,
  height = postHeight,
  className,
  leftPadded,
  maxLines = 3,
}: Props) => {
  const {
    redStrip,
    imageObj,
    title,
    secondaryTitle,
    isBlank,
    background,
    promotedStripText,
    video,
    link: postLink,
  } = post
  const postContainerRef = useRef<HTMLDivElement | null>(null)

  const linkTarget = isBlank ? '_blank' : undefined
  const page = usePage()
  const isDarkTheme = page?.isDarkTheme || false
  const pageId = page?.PageMeta.id

  const { gridId } = useGridBlock()

  const link = utils.addPageQueryParams(postLink, pageId, gridId)
  const hide_date = useMemo(() => shouldHideDate(postLink), [postLink])
  const RedStrip = dynamic(() => import('../RedStrip/RedStrip'))

  useEffect(() => {
    if (isHomepage(page) && postContainerRef.current) {
      postContainerRef.current.dataset.tbRegionItem = ''
    }
  }, [page])
  return (
    <Container
      layout={layoutMobile}
      backgroundColor={background}
      height={height}
      className={className}
      hideSecondaryTitle={hideSecondaryTitle}
      ref={postContainerRef}
    >
      <Thumbnail href={link} target={linkTarget} isDarkTheme={isDarkTheme}>
        {redStrip && <RedStrip {...redStrip} />}
        <ThumbnailContainer>
          <Image image={imageObj} alt={title} />
        </ThumbnailContainer>
        {promotedStripText && <PromoStrip>{promotedStripText}</PromoStrip>}
        {video && <PlayButton />}
      </Thumbnail>
      <TextContainer
        leftPadded={leftPadded}
        layout={layoutMobile}
        hideSecondaryTitle={hideSecondaryTitle}
        backgroundColor={background}
      >
        <Link href={link} target={linkTarget}>
          <Shave maxLines={maxLines}>
            <Title isDarkTheme={isDarkTheme}>{title}</Title>
          </Shave>
        </Link>
        {!hideSecondaryTitle && secondaryTitle && (
          <SecondaryTitle
            href={link}
            target={linkTarget}
            isDarkTheme={isDarkTheme}
          >
            {secondaryTitle}
          </SecondaryTitle>
        )}
        <Credits
          credits={post}
          color={isDarkTheme ? colors.white : '#999'}
          hide_date={hide_date}
        />
      </TextContainer>
    </Container>
  )
}
